import type { SystemResource } from '@xianlaibang/shared/types'

export function useSystemResources() {
  const resources = useState<SystemResource[]>('system-resources', () => [])

  function setResources(value?: SystemResource[]) {
    resources.value = Array.isArray(value) ? value : []
  }

  function getResourceImage(name: string) {
    const imagePath = resources.value.find(item => item.name === name)?.imagePath
    return Array.isArray(imagePath) ? imagePath[0] || '' : imagePath || ''
  }

  return {
    resources,
    setResources,
    getResourceImage,
  }
}
